export default __webpack_public_path__ + "static/media/Arte_ganoso_full_body.4b8ba4f8.png";